(function () {
    'use strict';
    const DEBUG = false;
    const log = (...a) => { if (DEBUG) console.log(...a); };
    const err = (...a) => { if (DEBUG) console.error(...a); };

    const COMPANY_ID = "RU2ww8";
    const REVISION = "2025-07-15";
    const EMAIL_MARKETING_LIST_ID = "YvUwiM";
    const ENDPOINT = "https://a.klaviyo.com/client/profiles";
    const isEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

    function subscribeToEmailMarketing(email) {
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: "SUBSCRIBED"
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: EMAIL_MARKETING_LIST_ID
              }
            }
          }
        }
      };

      const url = new URL("https://a.klaviyo.com/client/subscriptions/");
      url.searchParams.set("company_id", COMPANY_ID);

      return fetch(url.toString(), {
        method: "POST",
        headers: {
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          revision: REVISION
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) {
          throw new Error(`Marketing subscription failed (${response.status})`);
        }
      });
    }

    function handleWaitlist(form, evt) {
        if (evt) evt.preventDefault();
        const waitlistId = form.getAttribute("waitlist-id") || form.dataset.waitlistId || "";
        const emailInput = form.querySelector("#waitlist-email, input[type='email']");
        const email = (emailInput?.value || "").trim();

      if (!email || !isEmail(email)) {
        showMessage(form, "Please enter a valid email", "error");
        emailInput?.focus();
        return;
      }

      if (!waitlistId) {
        showMessage(form, "Missing waitlist-id on .waitlist-form", "error");
        return;
      }

        subscribeToEmailMarketing(email)
        .catch(function (e) {
          err("Klaviyo marketing subscription request failed before waitlist submit.", e);
        })
        .then(function () {
          const payload = { data: { type: "profile", attributes: { email, properties: { waitlistID: waitlistId } } } };
          const url = new URL(ENDPOINT); url.searchParams.set("company_id", COMPANY_ID);

          fetch(url.toString(), {
            method: "POST",
            headers: { accept: "application/vnd.api+json", "content-type": "application/vnd.api+json", revision: REVISION },
            body: JSON.stringify(payload)
          })
          .then(async res => {
            const text = await res.text().catch(() => "");
            if (res.status === 202 || res.ok) {
              showMessage(form, "Thanks, love! We'll send you an email as soon as it's live.", "success");
              const actualForm = form.querySelector("form");
              if (actualForm) {
                actualForm.reset();
              }
            } else {
              showMessage(form, "Klaviyo waitlist failed", "error");
            }
          })
          .catch(e => {
            showMessage(form, "Klaviyo request error", "error");
          });
        });
    }

    document.addEventListener("submit", e => {
        const form = e.target.closest(".waitlist-form");
        if (form) handleWaitlist(form, e);
    });

    document.addEventListener("click", e => {
        const btn = e.target.closest(".notify-me-btn");
        if (!btn) return;
        const form = btn.closest(".waitlist-form");
        if (form) handleWaitlist(form, e);
    });

    function showMessage(form, message, type) {
      // Find the message div
      const messageDiv = form.parentNode.querySelector(".waitlist-message");
      if (!messageDiv) {
        return;
      }

      // Clear any existing content
      messageDiv.innerHTML = "";
      messageDiv.className = "waitlist-message";

      // Set message content
      messageDiv.textContent = message;

      // Apply styling based on type
      if (type === "error") {
        messageDiv.style.color = "#c00";
        messageDiv.style.fontWeight = "400";
        messageDiv.classList.add("error-message");
      } else if (type === "success") {
        messageDiv.style.color = "#000";
        messageDiv.style.fontWeight = "bold";
        messageDiv.classList.add("success-message");
      }

      // Common styling
      messageDiv.style.fontSize = "13px";
      messageDiv.style.padding = "8px";
      messageDiv.style.display = "block";
    }
})();
